import React from 'react';
import { TrendPill } from './primitives';

// A responsive row of compact KPI tiles. tiles: [{ label, value, trend:{value,goodWhenUp}, hint }]
export const StatTiles = ({ tiles = [] }) => (
  <div className="cd-tiles">
    {tiles.map((t, i) => (
      <div className="cd-tile" key={t.label || i}>
        <div className="cd-tile-top">
          <span className="cd-tile-value">{t.value}</span>
          {t.trend != null && <TrendPill value={t.trend.value} goodWhenUp={t.trend.goodWhenUp !== false} />}
        </div>
        <div className="cd-tile-label">{t.label}</div>
        {t.hint && <div className="cd-tile-hint">{t.hint}</div>}
      </div>
    ))}
  </div>
);
